import { RootState } from '../..';
import { Contest } from './types';

export const selectOngoingContest = (state: RootState): Contest => {
    return state.public.contest.ongoingContest;
};

export const selectContestDetail = (state: RootState): Contest | null => {
    return state.public.contest.contestDetail;
};

export const selectLoadingContest = (state: RootState): boolean => {
    return state.public.contest.loading;
};